import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-try-again",
  templateUrl: "./try-again.component.html",
  styleUrls: ["./try-again.component.css"],
})
export class TryAgainComponent implements OnInit, OnDestroy {
  config;
  profile;
  leaving = new Subject();
  constructor(private um: UserManager, private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit(): void {
    this.um
      .getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe((profile) => (this.profile = profile));
  }

  ngOnDestroy() {
    this.leaving.next();
  }

  register() {
    this.um.openSignUpAndThenGoToLesson();
  }
}
